module.exports = __webpack_public_path__ + "img/selected0-min.fa95787b.png";